import "./CustomizationInfo.less";
import React, { useMemo } from "react";
import { Tooltip } from "antd";
import { SEOrderParsedCustomizationInfo } from "@/dto/order/CustomizationInfoDTO";
import ProxyImage from "@/components/ProxyImage";
import { observer } from "mobx-react-lite";
import moment from "moment";

function convertAliCdnImageQuantity(url?: string, reWidth = 400, quantity = 90) {
    if (!url) {
        return url;
    }

    try {
        const urlParsed = new URL(url);

        if (urlParsed.host === "isv.alibabausercontent.com" || urlParsed.host === "img.alicdn.com") {
            return `${url}_${reWidth}x${reWidth}q${quantity}`;
        }

        if (urlParsed.host?.endsWith(".aliyuncs.com") || urlParsed.host?.endsWith("customizationweboss.fahuoyi.com")) {
            if (!urlParsed.searchParams.get("Signature")) {
                urlParsed.searchParams.set("x-oss-process", `image/resize,w_${reWidth}/quality,q_${quantity}`);
            }

            return urlParsed.toString();
        }
    } catch (error) {}

    return url;
}

interface CustomizationInfoProps {
    info: SEOrderParsedCustomizationInfo;
}

const CustomizationInfo: React.FC<CustomizationInfoProps> = function (props) {
    const { info } = props;

    const hide = useMemo(() => {
        if (!info) {
            return false;
        }

        try {
            const isTbTempOssUrl = !!info.pic.startsWith(
                "https://miniappcloud-common-file.oss-cn-zhangjiakou.aliyuncs.com",
            );
            const hasLhOssUrl = !!info.ossUrl;

            const parsed = new URL(info.pic);

            const expires = parsed.searchParams.get("Expires") + "000";

            if (isTbTempOssUrl) {
                if (moment().isBefore(moment(Number(expires)))) {
                    return false;
                }

                if (!hasLhOssUrl) {
                    return true;
                }
            }

            return false;
        } catch (error) {
            return false;
        }
    }, [info]);

    if (!info) {
        return null;
    }

    // 如果是淘宝临时链接,并且没有缓存到lh的oss, 则代表有问题
    if (hide) {
        return (
            <div>
                <p className="text-error mb5">暂时无法查看</p>
                <div>原因: 定制图失效</div>
            </div>
        );
    }

    const smallPic = convertAliCdnImageQuantity(info.ossUrl || info.pic);
    const smallEffectPic = convertAliCdnImageQuantity(info.effectPic);

    const originalPicEl = (
        <ProxyImage src={info.ossUrl || info.pic} alt="" style={{ width: "100%" }} crossOrigin="anonymous" />
    );
    const originalEffectPicEl = (
        <ProxyImage src={info.effectPic} alt="" style={{ width: "100%" }} crossOrigin="anonymous" />
    );

    const phoneCaseContent = [info.brand, info.model, info.material, info.bgColorName].filter((it) => !!it).join("-");
    const commonContent = [info.bottomPanelName, info.aspectName].filter((it) => !!it).join("-");

    const content = commonContent || phoneCaseContent;

    return (
        <div className="ec-customization-info-item-container">
            {smallPic ? (
                <Tooltip destroyOnHidden title={originalPicEl}>
                    <span className="customization-image">
                        <ProxyImage src={smallPic} alt="" crossOrigin="anonymous" />
                    </span>
                </Tooltip>
            ) : null}

            {smallEffectPic ? (
                <Tooltip destroyOnHidden title={originalEffectPicEl}>
                    <span className="customization-image">
                        <ProxyImage src={smallEffectPic} alt="" crossOrigin="anonymous" />
                    </span>
                </Tooltip>
            ) : null}

            <span className="content">{content}</span>

            <span className="quantity">×{info.quantity}</span>
        </div>
    );
};

export default observer(CustomizationInfo);
